import type { ReactNode } from 'react';
import { ProductImage } from './ProductImage';

/** Shared customer/staff SKU layout; management screens always reserve the photo. */
export function MobileSkuCard({ productId, imageUrl, code, name, specification, unit, skuCode, reserveImage = false, selected = false, children }: {
  productId: string;
  imageUrl?: string | null | undefined;
  code: string;
  name: string;
  specification: string;
  unit: string;
  skuCode?: string | undefined;
  reserveImage?: boolean;
  selected?: boolean;
  children: ReactNode;
}) {
  return <article className={`mobile-sku${selected ? ' is-selected' : ''}`}>
    <header>
      {(reserveImage || imageUrl) && <div className={`product-image${reserveImage ? ' mobile-sku__image-slot' : ''}`}><ProductImage productId={productId} imageUrl={imageUrl} alt={`${name}主图`} /></div>}
      <div className="mobile-sku__identity"><span className="product-code">商品编号 {code}</span><h3>{name}</h3>
        <p>规格：{specification} · 单位：{unit}</p>
        {skuCode && skuCode !== code && <small>SKU 编号 {skuCode}</small>}
      </div>
    </header>
    {children}
  </article>;
}
